export const catalogConfig = {
	clientPerPage: 12,
}

export const CATALOG_TITLE_ID = 'plp-title'
